export const mapKeys = <T>(f: (x: string) => string, a: Record<string, T>): Record<string, T> =>
	Object.fromEntries(Object.entries(a).map(([key, value]) => [f(key), value]));
